export const faqs = [
  {
    question: '种子搜索是什么？',
    answer: '种子搜索是一个高效的BT资源检索工具，帮助用户快速定位磁力链接与种子文件。我们聚合了海量的DHT网络数据，支持影视、音乐、软件、游戏、电子书等多种资源类型的搜索，为用户提供精准、快速的资源发现服务。',
  },
  {
    question: '如何使用种子搜索查找资源？',
    answer: '在首页搜索框中输入你想要的资源名称或关键词，点击搜索即可获得相关结果。你可以使用高级筛选功能按文件大小、发布时间、资源类型等维度缩小搜索范围，更快找到目标资源。',
  },
  {
    question: '磁力链接和种子文件有什么区别？',
    answer: '种子文件（.torrent）需要先下载到本地再用BT客户端打开，而磁力链接是一段以"magnet:?"开头的链接，直接复制到BT客户端即可开始下载。磁力链接更方便快捷，不依赖Tracker服务器，通过DHT网络发现资源。',
  },
  {
    question: '种子搜索是完全免费的吗？',
    answer: '是的，种子搜索对所有用户完全免费开放。我们致力于为互联网用户提供便捷高效的资源检索服务，不收取任何费用。',
  },
  {
    question: '搜索结果的排序依据是什么？',
    answer: '搜索结果的排序综合考量了多个维度，包括资源相关性、种子活跃度（做种数/下载数）、资源发布时间、文件完整度等。我们的排序算法持续优化，确保最优质、最活跃的资源排在前面。',
  },
  {
    question: '如何判断一个资源是否安全可靠？',
    answer: '建议关注以下几点：优先选择种子数量多、评论正面的资源；查看文件大小是否合理（如一部高清电影通常在2GB-10GB之间）；对下载文件进行杀毒扫描；避免下载可疑的可执行文件。',
  },
  {
    question: '种子搜索支持哪些类型的资源？',
    answer: '我们支持影视、音乐、软件、游戏、电子书、素材模板、课程教程等多种资源类型的搜索。我们的数据库涵盖数百个资源类别，几乎可以满足你对任何数字资源的需求。',
  },
  {
    question: '搜索不到想要的资源怎么办？',
    answer: '可以尝试以下方法：使用不同的关键词组合（中英文、简写、别名）；放宽筛选条件；检查是否有输入错误。如果仍然找不到，资源可能尚未被收录，请稍后再试。我们的数据库在持续更新中。',
  },
];

export const stats = [
  { icon: 'ri-database-2-line', value: '5000万+', label: '资源索引总量', color: 'primary' },
  { icon: 'ri-user-3-line', value: '800万+', label: '月活跃用户', color: 'accent' },
  { icon: 'ri-search-line', value: '3.2亿+', label: '月搜索次数', color: 'secondary' },
  { icon: 'ri-time-line', value: '0.3秒', label: '平均响应速度', color: 'primary' },
];